import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  buttonBase: {
    position: 'fixed',
    transform: 'translate(-50%, -16px)',
    bottom: '0',
    color: 'white',
    zIndex: 2,
    fontWeight: 700,
    fontSize: '16px',
    width: '40%',
    left: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      left: '50%',
    },
  },
}));
